export default function(data) {
  var self = this;
  self.alert = ko.observable();

  self.dismiss = function(alertId) {
    new Kadenze.AjaxRequest({
      url: Kadenze.Routes.dismiss_site_alert_path(alertId),
      type: 'PATCH'
    });

    $('#js-site-alert-' + alertId).slideUp();
  };

  self.initUI = function() {
    var $eles = $('.confirmation-notification__copy a');
    $eles.attr('data-skip-pjax', true);
    $eles.attr('target', '_blank');
  };

  const __construct = function (that) {
    self.initUI();
  }(this);
}
